// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadUploadStatusReportRequestModel from '../../model/download-upload-status-report-request-model';
import DownloadUploadStatusReportRequestDTO from '../dto/download-upload-status-report-request-dto';
import dtoSchema from '../schemas/download-upload-status-report-request-schema';

export default abstract class DownloadUploadStatusReportRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadUploadStatusReportRequestDTO>) {
    super();
    if (data) {
      this.redebitIds = data.redebitIds;
    }
  }
  /**
  */
  redebitIds?: number[];

  static toModel(dto: DeepPartial<DownloadUploadStatusReportRequestDTO>): DownloadUploadStatusReportRequestModel;
  static toModel(dto: DeepPartial<DownloadUploadStatusReportRequestDTO> | undefined | null): DownloadUploadStatusReportRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadUploadStatusReportRequestDTO> | undefined | null): DownloadUploadStatusReportRequestModel | undefined {
    return dto ? new DownloadUploadStatusReportRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadUploadStatusReportRequestModel> | DownloadUploadStatusReportRequestModel): DownloadUploadStatusReportRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      redebitIds: unwrapped.redebitIds,
    } as DownloadUploadStatusReportRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadUploadStatusReportRequestModel, can not map to DownloadUploadStatusReportRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
